import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Confirmar", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_tipo_documento_financeiro = _resolveComponent("selecionar-tipo-documento-financeiro")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    style: {"width":"900px"}
  }, {
    title: _withCtx(() => [
      _createTextVNode("Copiar Definições do Tipo de Documento")
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.salvar && _ctx.salvar(...args)))
      }, _hoisted_2)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_form_item, {
                label: "Tipo de documento Selecionado",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_selecionar_tipo_documento_financeiro, {
                    empresas: [_ctx.props.empresa],
                    codigoSelecionado: _ctx.props.tipoDocumentoFinanceiro,
                    "onUpdate:codigoSelecionado": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.props.tipoDocumentoFinanceiro) = $event)),
                    disabled: ""
                  }, null, 8, ["empresas", "codigoSelecionado"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_a_form_item, {
                label: "Copiar para os tipos de documentos",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_selecionar_tipo_documento_financeiro, {
                    empresas: [_ctx.props.empresa],
                    varios: true,
                    omitirTiposDocumentos: [_ctx.props.tipoDocumentoFinanceiro],
                    codigosSelecionados: _ctx.state.codigosSelecionados,
                    "onUpdate:codigosSelecionados": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.codigosSelecionados) = $event))
                  }, null, 8, ["empresas", "omitirTiposDocumentos", "codigosSelecionados"])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}